<template lang="pug">
.study-start
  //- ヘッダー部
  .study-start__header
    button-return.study-start__header__button(@click='moveReturnEvent')
      slot(name='returnButtonText')
  //- メイン部
  .study-start__main
    .study-start__main__title-area
      .study-start__main__title-area__title.text-large.font-bold
        .study-start__main__title-area__title__text(v-if='showLastMinuteCheckTitle')
          slot(name='lastMinuteCheckTitleText')
        .study-start__main__title-area__title__text(v-if='showResolveTitle')
          slot(name='resolveTitleText')
      .study-start__main__title-area__subtitle
        .study-start__main__title-area__subtitle__text {{ title }}
    .study-start__main__button-area
      template(v-if='isLearned')
        button-primary.study-start__main__button-area__button(
          @click='startButtonEvent(false)'
        )
          slot(name='retryAllButtonLabel')
        button-primary.study-start__main__button-area__button(
          @click='startButtonEvent(true)'
        )
          slot(name='retryMistakeButtonLabel')
      button-primary.study-start__main__button-area__button(
        v-else,
        @click='startButtonEvent'
      )
        slot(name='startButtonLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonReturn from '@/components/molecules/student/ButtonReturn.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import { SUnitCategorySetting } from '@/const/ApiSettings'

/**
 * テスト扉画面テンプレート
 */
@Component({
  components: {
    ButtonReturn,
    ButtonPrimary,
  },
})
export default class StudyStart extends Vue {
  // タイトル文字列
  @Prop()
  title!: string

  // カテゴリー（直前チェックCBT/解きなおしCBT）
  @Prop()
  category!: SUnitCategorySetting

  // 学習済みフラグ
  @Prop()
  isLearned!: boolean

  // 戻るボタン押下時イベント
  @Prop()
  moveReturnEvent!: Function

  // 学習開始ボタンイベント
  @Prop()
  startButtonEvent!: Function

  // 直前チェックタイトル表示フラグ
  private get showLastMinuteCheckTitle(): boolean {
    return this.category === SUnitCategorySetting.LAST_MINUTE_CHECK
  }

  // 解きなおしタイトル表示フラグ
  private get showResolveTitle(): boolean {
    return this.category === SUnitCategorySetting.RESOLVE
  }
}
</script>

<style lang="stylus" scoped>
.study-start
  height 100%
  margin 0 20px
  padding 20px 0

  &__header
    display flex
    align-items center
    padding 10px
    background-color var(--color-study-list-head__background)

    &__button
      width 180px

  &__main
    width 100%
    height calc(100% - 96px)
    display flex
    flex-direction column
    justify-content center
    align-items center
    gap 80px

    &__title-area
      display flex
      flex-direction column
      align-items center
      gap 10px

    &__button-area
      display flex
      gap 10px
</style>
